/**
 * Centralized configuration for Service Categories and their default availability.
 * This acts as the single source of truth for default operating hours.
 */

export const SERVICE_CATEGORIES = {
  WORK: "WORK",
  STAY: "STAY",
  PLAY: "PLAY",
};

export const DURATION_TYPES = {
  HOURLY: "HOURLY",
  DAILY: "DAILY",
  WEEKLY: "WEEKLY",
  MONTHLY: "MONTHLY",
};

/**
 * Default availability configuration for each category.
 * Can be extended in the future to come from an API.
 */
export const AVAILABILITY_CONFIG = {
  [SERVICE_CATEGORIES.WORK]: {
    defaultDuration: DURATION_TYPES.HOURLY,
    defaultStart: "00:00",
    defaultEnd: "23:59",
    isOvernight: false,
    rules: {
      [DURATION_TYPES.HOURLY]: {
        startTime: "00:00",
        endTime: "23:59",
        spansOvernight: false,
      },
      [DURATION_TYPES.DAILY]: {
        startTime: "00:00", // Start of day
        endTime: "23:59", // End of day
        spansOvernight: false,
      },
      [DURATION_TYPES.WEEKLY]: {
        startTime: "00:00",
        endTime: "23:59",
        spansOvernight: false,
      },
    },
  },
  [SERVICE_CATEGORIES.STAY]: {
    defaultDuration: DURATION_TYPES.DAILY,
    defaultStart: "00:00",
    defaultEnd: "23:59",
    isOvernight: false,
    rules: {
      [DURATION_TYPES.HOURLY]: {
        startTime: "00:00",
        endTime: "23:59",
        spansOvernight: false,
      },
      [DURATION_TYPES.DAILY]: {
        startTime: "00:00", // Check-in time
        endTime: "23:59", // Check-out time (same day)
        spansOvernight: false,
      },
      [DURATION_TYPES.WEEKLY]: {
        startTime: "00:00",
        endTime: "23:59",
        spansOvernight: false,
      },
      [DURATION_TYPES.MONTHLY]: {
        startTime: "00:00",
        endTime: "23:59",
        spansOvernight: false,
      },
    },
  },
  [SERVICE_CATEGORIES.PLAY]: {
    // Placeholder for future
    defaultDuration: DURATION_TYPES.HOURLY,
    defaultStart: "10:00",
    defaultEnd: "22:00",
    isOvernight: false,
    rules: {
      [DURATION_TYPES.HOURLY]: {
        startTime: "10:00",
        endTime: "22:00",
        spansOvernight: false,
      },
    },
  },
};
